import {RefreshControl, RefreshControlProps} from 'react-native';
import React from 'react';
import defaultTheme from 'design-system/src/Theme/defaultTheme';

const MainRefreshControl = (props: RefreshControlProps) => {
  return <RefreshControl tintColor={defaultTheme.primary} {...props} />;
};

export default React.memo(MainRefreshControl);
